import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { RestUserService } from '../user/api-rest/rest-user.service';
import { CustomErrorMessageService } from './custom-error-handler/custom-error-message-service.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  private isRedirecting = false;
  private logoutInProgress = false;
  private sessionInvalidated = false;

  constructor(
    private router: Router,
    private userService: RestUserService,
    private translate: TranslateService,
    private errorMessageService: CustomErrorMessageService,
  ) { }

  handleHttpError(error: any, url: string, isSilent: boolean) {
    if (this.sessionInvalidated) return;

    switch (error.status) {
      case 0:
        if (!isSilent) this.showNetworkError(error);
        break;

      case 401:
        this.handle401(error, url, isSilent);
        break;

      case 440:
        this.clearAndRedirect();
        break;

      case 400:
      case 422:
        // Erreurs de validation champ par champ : c'est à l'appelant de les restituer, en
        // détaillant ce qu'il faut corriger. Un toast générique par-dessus serait redondant.
        if (error?.error?.validationErrors?.length) break;
        this.showToast(error);
        break;

      default:
        this.showToast(error);
    }
  }

  handleGraphQLError(graphQLErrors: readonly any[], networkError: any) {
    if (this.sessionInvalidated) return;

    if (networkError) {
      if (networkError.status === 401) {
        this.handle401({ error: networkError }, '/graphql', false);
        return;
      }

      this.showNetworkError(networkError);
      return;
    }

    if (graphQLErrors?.length) {
      for (const err of graphQLErrors) {
        const errorCode = this.errorMessageService.extractErrorCode(err);
        const classification = err?.extensions?.classification;
        const message = this.errorMessageService.extractErrorMessage(err);
        console.log("err: "+err)
        if (
          errorCode === 'FORCE_RECONNECT' || errorCode === 'USER_DISABLED'||
          classification === 'UNAUTHORIZED'
        ) {
          this.handle401({ error: networkError }, '/graphql', false);
          return;
        }

        this.GraphQlShowToast(message);
      }
    }
  }

  private handle401(error: any, url: string, isSilent: boolean) {
    const errorCode = error?.error?.errorCode;
     if (errorCode === 'FORCE_RECONNECT' || errorCode === 'USER_DISABLED') {

      if (this.isRedirecting) {
        return;
      }

      this.isRedirecting = true;

      this.showToast(error);

      this.userService.clearSession();

      this.router.navigate(['/login']).finally(() => {
        this.isRedirecting = false;
      });

      return;
    }

    if (!isSilent && !this.logoutInProgress) {

      this.logoutInProgress = true;

      this.userService.logoutAndRedirect();

      setTimeout(() => {
        this.logoutInProgress = false;
      }, 1000);
    }
  }

  refreshCsrfAndRetry(): Observable<any> {
    return this.userService.getCsrf();
  }
  private clearAndRedirect() {
    this.userService.clearSession();
    this.router.navigate(['/login']);
  }

  showToast(error: any, icon: 'error' | 'warning' | 'success' = 'error') {
    Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    }).fire({
      icon,
      title: error?.error?.message || error.message || 'unknow Error',
    });
  }
  GraphQlShowToast(
    error: any,
    icon: 'error' | 'warning' | 'success' = 'error',
  ) {
    Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    }).fire({
      icon,
      title: error,
    });
  }

  private showNetworkError(error: any) {
    const isJulia = error.url.includes('/api/v1');
    if (isJulia) return;
    Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 4000,
    }).fire({
      icon: 'error',
      title: `${error.name}: ${error.status}`,
      text: this.translate.instant('service_not_available'),
    });
  }
}
